export default {
  'language.usd': 'Dollar',
  'language.eur': 'Euro',
  'language.rub': 'Rubl',
  'language.yen': 'Yen',
  'language.german': 'Deutsche',
  'language.italian': 'Italiano',
  'language.arabic': 'عربی',
  'language.french': 'Français',
  'language.spanish': 'Español',
  'language.russian': 'русский',
  'language.english': 'English',
  'language.japanese': 'Japanese',
  'language.iran': 'فارسی',
  'language.rial': 'Rial',
  'component.select': 'Select',
  'form.requierd': 'REQUIRED',
  'form.isshort': 'Too Short',
  'form.islong': 'Too Long',
  'form.invalid': 'Invalid',
  'form.number': 'must be a number',
  'alert.info': 'Info',
  'alert.warning': 'Warning',
  'alert.error': 'Erro',
  'alert.notitle': ' ',
  'alert.success': 'Success',
  'errorBoundary.oops': 'Oops!!',
  'errorBoundary.weSearched': 'The desired page was not found.',
  'errorBoundary.backToHome': 'Back To Home',
  'error.receiveerror': 'Error in receiving information',
  NextStep: 'Next Step',
  Previous: 'Previous',
  FirstName: 'FirstName',
  LastName: 'LastName',
  BirthDate: 'Birth Date',
  NationalCode: 'National Code',
  Yes: 'Yes',
  No: 'No',
  Jalali: 'Jalali',
  Miladi: 'Miladi',
  Hijri: 'Hijri',
  'faq.faq': 'FAQs ',
  'faq.firstquestion': "What is Tripsi Group's mission?",
  'faq.firstanswer':
    'Our mission is “to make it easy to do business anywhere.” Our founders started our company to champion small businesses, in the belief that the Internet would level the playing field by enabling small enterprises to leverage innovation and technology to grow and compete more effectively in domestic and global economies. We believe that concentrating on customer needs and solving their problems – whether those customers are consumers, merchants or enterprises – ultimately will lead to the best outcome for our business.',
  'faq.secendquestion': 'When was TripsiGroup founded?',
  'faq.secendanswer':
    'Tripsi Group was founded in 2022 by 18 people led by Mehdi Abdollahi mehr,  It began as an online wholesale marketplace for small Iraininan exporters and entrepreneurs to reach global buyers.',
  'faq.thirdquestion': 'Where are Tripsi Group’s offices located?',
  'faq.thirdanswer':
    'We maintain offices in many countries and regions, including mainland China, Hong Kong S.A.R., Singapore and the United States. In addition, we maintain data centers in a number of countries including China, Indonesia, Malaysia, Australia, Singapore, the UAE, Germany, the UK, Japan and the U.S.',
};
